module.exports = __webpack_public_path__ + "static/media/q3-19-bg.4b15ee1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/RoadMapResources/q3-19-bg.svg
// module id = 200
// module chunks = 0